import { tw } from "@careinfo/tailwind";
import moment from "moment";
import { useState } from "react";
import APIS from "../../constant/Endpoint";
import useGetHook from "../../customHooks/useGetHook";
import usePatchHook from "../../customHooks/usePatchHook";
import EditIcon from "../../Icons/EditIcon";
import { responsiveClassName } from "../../utils/classNames";
import CustomerInfo, { Loader } from "./components/CustomerInfo";
import { getKey } from "../../helpers/sessionKey";
import { ClientAccessControl } from "@careinfo/permission-required";
import { toast } from "react-toastify";

export default ({ selectedOrder }) => {
  const [isEditable, setIsEditable] = useState(false);
  const [now, setNow] = useState(moment());

  const maxDateTime = now.format("YYYY-MM-DDTHH:mm");
  const { data: order, isLoading } = useGetHook({
    queryKey: [`order-${selectedOrder}`],
    url: `${APIS.ORDER}${selectedOrder}/`,
    params: {},
  });
  const { mutateAsync } = usePatchHook({
    queryKey: [`order-${selectedOrder}`],
  });

  const handleUpdateDate = async (e: any) => {
    const inputDateTime = moment(e.target.value);
    if (inputDateTime.isAfter(now)) {
      toast.error("Future date/time not allowed");
      return;
    }
    const url = `${APIS.ORDER}${selectedOrder}/update-created/`;
    const formData = {
      date: e.target.value,
    };

    try {
      const res = await mutateAsync({
        url,
        formData,
        setError: () => {},
      });
    } catch (err) {
      console.error(err);
    } finally {
      setIsEditable(false);
    }
  };
  const isSuperUser = getKey("is_superuser");

  return (
    <>
      <div className={tw`flex justify-around text-3xl font-bold`}>
        <div className={tw`text-sm md:text-2xl`}>
          {isLoading ? <Loader /> : <p>{order?.pickup_branch?.name}</p>}
        </div>
        <div className={tw`text-sm md:text-2xl`}>---------</div>
        <div className={tw`text-sm md:text-2xl`}>
          {isLoading ? <Loader /> : <p>{order?.destination?.name}</p>}
        </div>
      </div>
      <div
        className={responsiveClassName(
          "grid grid-cols-1  mt-2 border ",
          `grid grid-cols-2  mt-2 border  `
        )}
      >
        <div className={tw`border-r-[1px]`}>
          <p
            className={tw`md:text-md w-full font-semibold whitespace-nowrap text-center my-1`}
          >
            Order Details
          </p>
          <div
            className={responsiveClassName(
              "flex flex-col justify-center items-start  px-2 ",
              "grid grid-cols-2 justify-start gap-x-2 px-4 "
            )}
          >
            <div className={tw`text-sm  space-y-1`}>
              <p className={tw`font-bold whitespace-nowrap`}>
                Waybill: {isLoading ? <Loader /> : order?.tracking_number}
              </p>
              <p className={tw``}>
                Ref. Number: {isLoading ? <Loader /> : order?.reference_number}
              </p>
              <p>COD: {isLoading ? <Loader /> : order?.cod}</p>
            </div>

            <div className={tw`text-sm whitespace-nowrap`}>
              <div className={tw`flex items-center`}>
                <span>Date:</span>
                {isLoading ? (
                  <Loader />
                ) : (
                  <span className={tw`flex items-center gap-x-2`}>
                    {isEditable ? (
                      <input
                        type="datetime-local"
                        max={maxDateTime}
                        defaultValue={
                          order?.created
                            ? moment(order.created).format("YYYY-MM-DDTHH:mm")
                            : ""
                        }
                        className={tw`focus:outline-none bg-[#EEF5F4] w-[170px]`}
                        onBlur={(e) => handleUpdateDate(e)}
                      />
                    ) : (
                      moment(order?.created).format("YY-MM-DD HH:mm:ss")
                    )}
                    <ClientAccessControl
                      allowedPermissions={["can_update_created_date"]}
                    >
                      {!isEditable && isSuperUser === "true" && (
                        <button
                          className={tw`focus:outline-none`}
                          onClick={() => setIsEditable(!isEditable)}
                        >
                          <EditIcon color={"var(--primary)"} />
                        </button>
                      )}
                    </ClientAccessControl>
                  </span>
                )}
              </div>
              <p>
                Weight: {isLoading ? <Loader /> : order?.total_weight}{" "}
                {order?.package_type?.unit}
              </p>
              <p>Piece: {isLoading ? <Loader /> : order?.total_piece}</p>
              <p>
                Collected COD: {isLoading ? <Loader /> : order?.collected_cod}
              </p>
            </div>
          </div>
        </div>
        <div
          className={responsiveClassName(
            "flex flex-col justify-center items-start px-2",
            "grid grid-cols-2 justify-items-starta gap-x-4 px-4"
          )}
        >
          <CustomerInfo
            info={order?.sender}
            isLoading={isLoading}
            title={"Sender"}
          />
          <CustomerInfo
            info={order?.receiver}
            isLoading={isLoading}
            title={"Receiver"}
          />
        </div>
      </div>
      <div className={tw`flex justify-between pt-4`}>
        <p>
          <span className={tw`font-bold`}>
            Description &#40;Note&#41; &#58;
          </span>
          {order?.delivery_instruction}
        </p>
        <p className={tw`font-bold`}>
          Service Type:{order?.service_type?.name ?? "N/A"}
        </p>
      </div>
    </>
  );
};
